import { useTranslation } from 'react-i18next'
import styles from './ClientMonthInstallments.module.css'
import { Link, useParams, useSearchParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { axiosConfig } from 'utils/axiosConfig'
import { Container } from 'react-bootstrap'
import AllOrderTestamentsTable from 'components/Tables/AlOrderTestamentsTable/AllOrderTestamentsTable'
import { useSelector } from 'react-redux'
import AllClientsInstallmentsTable from 'components/Tables/AllClientsInstallmentsTable/AllClientsInstallmentsTable'
import AllClientsInstallmentsMothsTable from 'components/Tables/AllClientsInstallmentsMothsTable/AllClientsInstallmentsMothsTable'
function ClientMonthInstallments() {
  const {t} =useTranslation()
  const params = useParams()
  const user =useSelector((state:any)=>state?.GlobalReducer?.user)
  const [searchParams , setSearchParams] = useSearchParams()
  const [item,setItem]=useState({} as any)
  const [installments,setInstallments]=useState([])
  const [monthInstallments,setMonthInstallments]=useState([])
  const [installment,setInstallment]=useState([])
  const [isLoading,setIsLoading]=useState(false)
  const [isDeleting,setIsDeleting] =useState<[Boolean]>([false])
  function getUserInstallments(){
    setIsLoading(true)
    axiosConfig.get(`/user/single-user-by-id/${params?.id}`,{
      headers: {
        "Authorization": `Bearer ${localStorage.getItem('token')}`,
        
      }
    }).then(res=>{
      setIsLoading(false)
      setItem(res.data?.data)
      let monthInstall = res.data?.data?.installments?.filter((installment:any)=>{
        console.log(installment?.id == searchParams.get('month_installment') , installment?.id , searchParams.get('month_installment'))
        return installment?.id == searchParams.get('month_installment')
      })?.[0]
      console.log(monthInstall)
      setInstallment(monthInstall)
      setMonthInstallments(monthInstall?.installment_months)
      // let deletedNumber:any = [...Array(res.data.data.length)]
      // setIsDeleting(deletedNumber)
    }).catch(err=>{
      setIsLoading(false)
      console.log(err)
    })
  }
  function deleteItem(userId:String ,index:any,testmentId:String){
    let modifiedDelete:[Boolean]=[...isDeleting]
      modifiedDelete[index]=true
    setIsDeleting(modifiedDelete)
      axiosConfig.delete(`/user/delete-installment-from-user/${userId}?installment_id=${testmentId}`,{
        headers: {
          "Authorization": `Bearer ${localStorage.getItem('token')}`
        }
      }).then(res=>{
        let modifiedDelete:[Boolean]=[...isDeleting]
        modifiedDelete[index]=false
        setIsDeleting(modifiedDelete)
        toast.success(t('Item Deleted Successfully'))
        getUserInstallments()
      }).catch(err=>{
        let modifiedDelete:[Boolean]=[...isDeleting]
        modifiedDelete[index]=false
        setIsDeleting(modifiedDelete)
        toast.error(err?.response?.data?.message)
        console.log(err)
      })
  }
  function receiveTestment(orderId:String ,index:any,testmentId:String,receivedStatus:String){
    let modifiedDelete:[Boolean]=[...isDeleting]
      modifiedDelete[index]=true
    setIsDeleting(modifiedDelete)
      axiosConfig.post(`/user/received-month-installment/${orderId}`,{installment_id:searchParams.get('month_installment'),installment_month_id:testmentId,paid_status:receivedStatus},{
        headers: {
          "Authorization": `Bearer ${localStorage.getItem('token')}`
        }
      }).then(res=>{
        let modifiedDelete:[Boolean]=[...isDeleting]
        modifiedDelete[index]=false
        setIsDeleting(modifiedDelete)
        toast.success(t('Item Changed Successfully'))
        getUserInstallments()
      }).catch(err=>{
        let modifiedDelete:[Boolean]=[...isDeleting]
        modifiedDelete[index]=false
        setIsDeleting(modifiedDelete)
        toast.error(err?.response?.data?.message)
        console.log(err)
      })
  }
  useEffect(()=>{
    getUserInstallments()
  },[])
  return (
    <>
      <section className={styles['page-wrapper']}>
        <Container>
          <div className={styles['page-header']}>
            <h1 className={styles['page-header__title']}>
            {t('Client Month Installments')} ({item?.name})
            </h1>
            {/* <Link to='/dashboard/add-technician' className={styles['page-header__link']}>
              {t('Export PDF')}
            </Link> */}
            {/* {
              user?.permission_type=='admin' &&
              <Link to={`/our-clients/add-client-installments/${params?.id}`} className={styles['page-header__link']}>
                {t('Add Installments')}
              </Link>
            } */}
          </div>
        </Container>
        <AllClientsInstallmentsMothsTable 
          getUserInstallments={getUserInstallments}
          order={item} 
          installment={installment} 
          items={monthInstallments} 
          receiveTestment={receiveTestment} 
          deleteItem={deleteItem} 
          isDeleting={isDeleting} 
        />
      </section>
    </>
  )
}

export default ClientMonthInstallments